import {
  BackgroundColors,
  NegativeColors,
  PositiveColors,
  PrimaryColors,
} from '@picsart/design-system/foundation/colors';
import { FontSizes, LineHeights } from '@picsart/design-system/foundation/typography';

import { FontWeights } from '@picsart/design-system/foundation/fonts';
import { CornerRadius } from '@picsart/design-system/foundation/cornerRadius';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import { mediaQuery } from '@picsart/rc/helpers';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(
  () => ({
    root: {
      fontWeight: FontWeights.semibold,
      padding: [Spacings.s64, Spacings.s0],

      // [mediaQuery(767)]: {
      '@media screen and (max-width: 767px)': {
        padding: [Spacings.s24, Spacings.s0],
      },
    },
    rootFallback: {
      width: '100%',
      maxWidth: 1320,
      margin: [Spacings.s0, 'auto'],

      '@supports (-webkit-touch-callout: none)': {
        paddingLeft: 'env(safe-area-inset-left)',
        paddingRight: 'env(safe-area-inset-right)',
      },

      [mediaQuery(1365)]: {
        maxWidth: '100%',
        padding: [Spacings.s0, Spacings.s44],
      },

      [mediaQuery(1023)]: {
        maxWidth: '100%',
        padding: [Spacings.s0, Spacings.s32],
      },

      // [mediaQuery(767)]: {
      '@media screen and (max-width: 767px)': {
        maxWidth: '100%',
        padding: [Spacings.s0, Spacings.s24],
      },
    },
    title: {
      margin: [Spacings.s0, Spacings.s0, Spacings.s24, Spacings.s0],
      fontSize: FontSizes.s24,
      lineHeight: LineHeights.l32,
      textAlign: 'center',

      // [mediaQuery(767)]: {
      '@media screen and (max-width: 767px)': {
        fontSize: FontSizes.s36,
        lineHeight: LineHeights.l48,
      },

      [mediaQuery(1365)]: {
        fontSize: FontSizes.s42,
        lineHeight: LineHeights.l50,
      },
    },
    titleFallback: {
      margin: [Spacings.s0, 'auto', Spacings.s24, 'auto'],
      height: 32,
      width: 360,
    },
    table: {
      width: '100%',
      borderCollapse: 'collapse',
      borderRadius: CornerRadius.r8,
      marginBottom: Spacings.s24,
    },
    row: {
      height: 48,
      listStyle: 'none',

      '&:nth-child(odd)': {
        backgroundColor: PositiveColors.base.default,
      },

      '&:nth-child(even)': {
        backgroundColor: BackgroundColors.tint1,
      },
    },
    colFallback: {
      display: 'table-cell',
    },
    col: {
      width: 200,
      height: '100%',
      minWidth: 68,
      border: `1px solid ${BackgroundColors.base}`,
    },
    colIcon: {
      display: 'inline-block',
      maxWidth: 55,
      height: 24,
      fill: PositiveColors.text.default,
    },
    colIconCompany: {
      display: 'inline-block',
      maxWidth: 55,
      height: 24,
      fill: PrimaryColors.base.default,
    },
    colName: {
      fontSize: FontSizes.s16,
      lineHeight: LineHeights.l32,
      textAlign: 'center',

      // [mediaQuery(766)]: {
      '@media screen and (max-width: 766px)': {
        fontSize: FontSizes.s12,
        lineHeight: LineHeights.l16,
        textAlign: 'center',
      },
    },
    featureCol: {
      width: '50%',
      minWidth: '50%',
      padding: [Spacings.s8, Spacings.s16],
      fontSize: FontSizes.s16,
      lineHeight: LineHeights.l32,

      // [mediaQuery(766)]: {
      '@media screen and (max-width: 766px)': {
        fontSize: FontSizes.s12,
        lineHeight: LineHeights.l24,
      },
    },
    featureColFallback: {
      padding: [Spacings.s8, Spacings.s0],
    },
    full: {
      height: 38,
      width: '98%',
      margin: [Spacings.s0, 'auto'],
    },
    markCol: {
      width: '25%',
      maxWidth: 260,
      padding: [Spacings.s8, Spacings.s4],
      minWidth: '25%',
      textAlign: 'center',
      verticalAlign: 'middle',
    },
    doneIcon: {
      fill: NegativeColors.base.default,
    },
    tableAction: {
      maxWidth: 'fit-content',
      padding: [Spacings.s16, Spacings.s32],
      margin: [Spacings.s0, 'auto'],
      fontWeight: FontWeights.semibold,
      fontSize: FontSizes.s16,
      lineHeight: LineHeights.l24,

      // [mediaQuery(766)]: {
      '@media screen and (max-width: 766px)': {
        width: '100%',
      },
    },
    tableActionFallback: {
      height: 56,
      minWidth: 200,
      maxWidth: 'fit-content',
      padding: [Spacings.s16, Spacings.s32],
      margin: [Spacings.s0, 'auto', Spacings.s24, 'auto'],

      // [mediaQuery(766)]: {
      '@media screen and (max-width: 766px)': {
        width: '100%',
      },
    },
  }),
  {
    name: 'comparison-table',
  },
);

export default useStyles;
